import Vue from "vue";

var validateInt = function ($this, maxLength, e, negative) {
    var passChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    if (negative) passChars.push("-");
    if (passChars.indexOf(e.key) < 0) e.preventDefault();
    if (negative && e.key === "-" && $this.selectionStart !== 0) e.preventDefault();
    var max = maxLength !== 0 ? maxLength : 8;

    var value = ($this.value.slice(0, $this.selectionStart) + $this.value.slice($this.selectionEnd, $this.value.length)).replace(',', '');

    if (value.replace('-', '').length >= max) e.preventDefault();
};

var validateFloat = function ($this, maxLength, e, negative, decimal) {

    var maxIntegerLength = maxLength !== 0 ? maxLength : 8;
    var maxDecimalLength = decimal || 2;

    var controlChars = ["ArrowLeft", "ArrowRight", "Home", "End"];
    var passChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ".", "Backspace", "Delete"];

    var ekey = e.key;

    if (controlChars.indexOf(ekey) >= 0) return;
    if (negative) passChars.push("-");
    if (passChars.indexOf(ekey) < 0) e.preventDefault();
    if (negative && ekey === "-" && $this.selectionStart !== 0) e.preventDefault();

    var value = ($this.value.slice(0, $this.selectionStart) + $this.value.slice($this.selectionEnd, $this.value.length)).replace(',', '');
    var integerLength = value.split('.')[0].length;
    var decimalLength = $this.value.indexOf('.') > -1 ? $this.value.split('.')[1].length : 0;

    if (e.key === 'Backspace' && $this.value.indexOf('.') + 1 === $this.selectionStart && value.replace('-', '').replace('.', '').length > maxIntegerLength) {
        e.preventDefault();
    }

    if (e.key === 'Delete' && $this.value.indexOf('.') - 1 === $this.selectionStart && value.replace('-', '').replace('.', '').length > maxIntegerLength) {
        e.preventDefault();
    }

    if (e.key === 'Backspace' || e.key === 'Delete') return;

    if (ekey === ".") {
        if (value.indexOf(".") > -1 || (value.length - $this.selectionEnd) > maxDecimalLength)
            e.preventDefault();
        else
            return;
    }

    if ($this.selectionStart > $this.value.indexOf('.')) {
        if (decimalLength >= maxDecimalLength) {
            e.preventDefault();
            return;
        }
    }

    if ($this.selectionStart > integerLength) return;
    if (integerLength >= maxIntegerLength) e.preventDefault();
};

Vue.directive('uint', {
    bind: function (el, binding) {
        var maxLength = 0;
        if (binding.value !== null && parseFloat(binding.value)) maxLength = binding.value;
        el.addEventListener('keypress', function () {
            validateInt(el, maxLength, event, false);
        }, false);
    }
});

Vue.directive('int', {
    bind: function (el, binding) {
        var maxLength = 0;
        if (binding.value !== null && parseFloat(binding.value)) maxLength = binding.value;
        el.addEventListener('keypress', function () {
            validateInt(el, maxLength, event, true);
        }, false);
    }
});

Vue.directive('ufloat', {
    bind: function (el, binding) {
        var maxLength = 0;
        if (binding.value !== null && parseFloat(binding.value)) maxLength = binding.value;
        el.addEventListener('keydown', function () {
            validateFloat(el, maxLength, event, false);
        }, false);
    }
});

Vue.directive('float', {
    bind: function (el, binding) {
        var maxLength = 0;
        var decimal = 2;

        if (binding.value !== null && parseFloat(binding.value)) {
            maxLength = binding.value;
        }
        else if (typeof binding.value === 'object') {
            maxLength = binding.value.maxLength || maxLength;
            decimal = binding.value.decimal || decimal;
        }

        el.addEventListener('keydown', function () {
            validateFloat(el, maxLength, event, true, decimal);
        }, false);
    }
});



// WEBPACK FOOTER //
// ./src/helpers/vue-number.js